<template>
  <div>
    <dialog-v2
      :show="show"
      :title="title"
      max-width="550px"
      @close="$emit('close')"
      @save="save">
      <template slot="content">
        <v-layout row wrap>
          <v-flex>
            <v-text-field
              v-model="form.name"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-scope="paymentPFilter"
              data-vv-as="nombre"
              :error-messages="errors.collect('paymentPFilter.name')"
              label="Nombre"
              color="black"/>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-text-field
              v-model="form.broken_promises"
              v-validate="'integer'"
              data-vv-name="broken_promises"
              data-vv-scope="paymentPFilter"
              data-vv-as="promesas rotas"
              :error-messages="errors.collect('paymentPFilter.broken_promises')"
              label="Promesas rotas"
              color="black"/>
          </v-flex>
        </v-layout>
        <v-subheader class="pl-0">
          Canales
        </v-subheader>
        <v-layout row wrap>
          <v-flex
            md2
            v-for="(channel, i) in filteredChannels"
            :offset-md2="!i"
            :key="`channel-${channel.id}`"
            class="text-xs-center">
            <v-menu offset-y>
              <v-btn
                icon
                slot="activator"
                @click="templateChannel = channel.name"
                :class="{ 'k-orange-linear-text': form[`send_${channel.name}`] }"
                class="channels-btn">
                <v-icon>
                  {{ channel.icon }}
                </v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  @click="form[`send_${channel.name}`] = +(!form[`send_${channel.name}`])">
                  <v-list-tile-title>
                    {{ form[`send_${channel.name}`] ? 'Desactivar' : 'Activar' }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="templateDialog = true">
                  <v-list-tile-title>Plantilla</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="pFilter.template_id && pFilter[channel.name] && channel.name !== 'human'" @click="testTemplate(channel)">
                  <v-list-tile-title>Probar</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </template>
    </dialog-v2>
    <template-dialog
      :show="templateDialog"
      :channel="templateChannel"
      :template="template"
      :append-vars="templateAppendVars"
      validation-scope="pTemplate"
      validation-email-scope="pCompanyEmail"
      @save="saveTemplate"
      @close="templateDialog = false" />
    <test-template-dialog
      :show="testTemplateDialog"
      :template-id="(pFilter.template || {}).id || 0"
      :channel="templateChannelId"
      validation-scope="pTestTemplate"
      @close="testTemplateDialog = false" />
  </div>
</template>

<script>
import _ from 'lodash';
import { setTimeout } from 'timers';
import TemplateDialog from '@/components/Templates/Index';
import TestTemplateDialog from '@/components/Templates/TestDialog';
import DialogV2 from '@/components/global/DialogV2';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import EventBus from '@/event-bus';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    pStage: {
      type: Object,
      required: true,
    },
    pFilter: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    DialogV2,
    TemplateDialog,
    TestTemplateDialog,
  },
  mixins: [
    channelsMixin,
    filtersMixin,
  ],
  data() {
    const emptyForm = {
      name: '',
      broken_promises: '',
      company_email_id: null,
      subject: '',
      send_email: 0,
      send_sms: 0,
      send_ivr: 0,
      send_human: 0,
      email: '',
      sms: '',
      ivr: '',
      human: '',
    };
    const templateAppendVars = [
      'moneda',
      'referencia',
      'fecha_vencimiento',
      'fecha_compromiso',
      ...workflowFiltersMixin.data()
        .map((item) => {
          varsList.push(`${item.title.toLowerCase().replace(/ /g, '_')}`);
        }),
    ];
    return {
      templateDialog: false,
      testTemplateDialog: false,
      templateChannel: '',
      templateChannelId: 0,
      emptyForm,
      form: {
        ...emptyForm,
      },
      templateAppendVars,
    };
  },
  computed: {
    title() {
      return `${!Object.keys(this.pFilter).length ? 'Crear' : 'Editar'} filtro`;
    },
    filteredChannels() {
      return this.channels.filter(item => ['email', 'sms', 'ivr', 'human'].includes(item.name));
    },
    template() {
      return {
        ...this.templateChannel === 'email' && {
          company_email_id: this.form.company_email_id,
          subject: this.form.subject,
        },
        text: this.form[this.templateChannel] || '',
      };
    },
  },
  methods: {
    testTemplate(id) {
      this.templateChannelId = id;
      this.testTemplateDialog = true;
    },
    saveTemplate(form) {
      this.form = {
        ...this.form,
        ...this.templateChannel === 'email' && {
          company_email_id: form.company_email_id,
          subject: form.subject,
        },
        [this.templateChannel]: form.text,
      };
    },
    save() {
      const wrongChannels = this.channels.filter(item => this.form[`send_${item.name}`] && !this.form[item.name]);
      if (wrongChannels.length) {
        EventBus.$emit('modal', `Los siguientes canales no tienen texto: ${wrongChannels.map(item => item.text).join(', ')}.`);
      }
      const activeChannels = this.channels.filter(item => this.form[`send_${item.name}`]).length !== 0;
      if (!activeChannels) {
        EventBus.$emit('modal', 'Debe activar al menos un canal');
      } else {
        this.$validator.validateAll('paymentPFilter').then((validation) => {
          if (validation && !wrongChannels.length) {
            if (Object.keys(this.pFilter).length) {
              this.axios.patch(`payment_p_filters/${this.pFilter.id}`, this.form)
                .then((response) => {
                  this.$emit('updated', response.data);
                  this.$emit('close');
                })
                .catch(() => {});
            } else {
              this.axios.post(`payment_p_stages/${this.pStage.id}/filters`, this.form)
                .then((response) => {
                  this.$emit('created', response.data);
                  this.$emit('close');
                }).catch(() => {});
            }
          }
        });
      }
    },
  },
  watch: {
    show() {
      if (!Object.keys(this.pFilter).length) {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
        }, 200);
      } else {
        this.form = {
          ..._.pick(this.pFilter, Object.keys(this.emptyForm)),
        };
      }
      if (!this.show) {
        setTimeout(() => {
          this.$validator.errors.remove('name', 'paymentPFilter');
        }, 500);
      }
    },
  },
};
</script>

<style scoped>
.btn.channels-btn {
  width: 50px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/PaymentPromiseTree/PFilterModal.vue